import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=406956a9&scoped=true"
import script from "./CButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CButton.vue?vue&type=style&index=0&id=406956a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406956a9",
  null
  
)

export default component.exports